export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["SERVICE"] = "SERVICE";
    UserRole["SERVER"] = "SERVER";
    UserRole["RECEPTION"] = "RECEPTION";
    UserRole["SUPPORT"] = "SUPPORT";
    UserRole["SALES"] = "SALES";
})(UserRole || (UserRole = {}));
